import React, { useMemo } from "react";
import { Link } from "react-router-dom";

import classNames from "classnames";
import { Table } from "react-bootstrap";

import { useRatingsContext } from "../contexts/Ratings";
import { setSortingClassNames } from "../lib/setSortingClassNames";
import { SortColumns } from "../types/ratings";

import { usePaginationContext } from "../../../../../../contexts/Pagination";

const RatingsTable = (): React.JSX.Element => {
    const { ratings, setSortColumn, setSortOrder, sortColumn } =
        useRatingsContext();
    const { page, itemsPerPage: ratingsPerPage } = usePaginationContext();

    const paginatedRatings = useMemo(() => {
        return ratings.slice(
            page * ratingsPerPage - ratingsPerPage,
            page * ratingsPerPage,
        );
    }, [ratings, page, ratingsPerPage]);

    const handleHeaderClick = (column: SortColumns) => {
        if (column !== sortColumn) {
            setSortColumn(column);
            setSortOrder("ascending");
        } else {
            setSortOrder(prev =>
                prev === "ascending" ? "descending" : "ascending",
            );
        }
    };

    return (
        <Table
            className={classNames("dataTable", "umpireRatingsTable")}
            striped
        >
            <thead>
                <tr>
                    <th
                        onClick={() => handleHeaderClick("name")}
                        className={classNames(setSortingClassNames("name"))}
                    >
                        Name
                    </th>
                    <th
                        onClick={() => handleHeaderClick("count")}
                        className={classNames(setSortingClassNames("count"))}
                    >
                        Number of Ratings
                    </th>
                    <th
                        onClick={() => handleHeaderClick("attitude")}
                        className={classNames(setSortingClassNames("attitude"))}
                    >
                        Attitude
                    </th>
                    <th
                        onClick={() => handleHeaderClick("consistency")}
                        className={classNames(
                            setSortingClassNames("consistency"),
                        )}
                    >
                        Consistency
                    </th>
                    <th
                        onClick={() => handleHeaderClick("effort")}
                        className={classNames(setSortingClassNames("effort"))}
                    >
                        Effort
                    </th>
                    <th
                        onClick={() => handleHeaderClick("overall")}
                        className={classNames(setSortingClassNames("overall"))}
                    >
                        Overall
                    </th>
                </tr>
            </thead>
            <tbody>
                {paginatedRatings.map(r => (
                    <tr key={r.umpire.id}>
                        <td style={{ width: "25%" }}>
                            <Link
                                to={`/admin/umpires/${r.umpire.id}`}
                                target="_blank"
                            >
                                {r.umpire.name}
                            </Link>
                        </td>
                        <td style={{ width: "15%" }}>{r.count || 0}</td>
                        <td style={{ width: "15%" }}>{r.attitude || "N/A"}</td>
                        <td style={{ width: "15%" }}>
                            {r.consistency || "N/A"}
                        </td>
                        <td style={{ width: "15%" }}>{r.effort || "N/A"}</td>
                        <td style={{ width: "15%" }}>{r.overall || "N/A"}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default RatingsTable;
